import {
  ResubmittableRow,
  StatusFilterParams,
  StatusFilterSplit,
} from "../types";

export const RESUBMISSION_FILTER_VALUE: string = "RESUBMISSION";

export const isResubmitted = (row: ResubmittableRow): boolean =>
  row.resubmission === true;

export const splitResubmissionFromStatus = (
  selected: readonly string[]
): StatusFilterSplit => ({
  statuses: selected.filter(
    (value: string): boolean => value !== RESUBMISSION_FILTER_VALUE
  ),
  resubmission: selected.includes(RESUBMISSION_FILTER_VALUE),
});

const selectedValuesOf = (
  status: readonly string[] | string | undefined
): readonly string[] => {
  if (!status) return [];

  return typeof status === "string" ? [status] : status;
};

export const statusFilterParamsOf = <TStatus extends string>(
  status: readonly string[] | string | undefined,
  knownStatuses: readonly TStatus[]
): StatusFilterParams<TStatus> => {
  const { statuses, resubmission }: StatusFilterSplit =
    splitResubmissionFromStatus(selectedValuesOf(status));

  const isKnownStatus = (value: string): value is TStatus =>
    knownStatuses.some((known: TStatus): boolean => known === value);

  const knownSelected: TStatus[] = statuses.filter(isKnownStatus);

  return {
    status: knownSelected.length > 0 ? knownSelected : undefined,
    resubmission: resubmission || undefined,
  };
};
